import { CSSProperties } from 'react';
import { CSSObject } from '@emotion/react';
import type { Corners } from '../../content-composer/types';

const CORNERS_STYLES = {
  square: '0',
  rounded: '4px',
  pill: '20px',
} as const;

const isValidCorner = (corners?: string): corners is Corners => {
  return Boolean(corners && corners in CORNERS_STYLES);
};

/**
 * Generates CSS styles for a Corners string
 * @param corners - The Corners string
 * @returns An object with applicable styles
 */
export const getCornersStyle = <T extends CSSObject | CSSProperties>(corners?: Corners): T => {
  if (!isValidCorner(corners)) return {} as T;

  return {
    borderRadius: CORNERS_STYLES[corners],
  } as T;
};
